import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { translate } from '../Services/translation';

export const CustomCarousel = ({ children }) => {
    const scrollContainerRef = useRef(null);
    const [scrollPosition, updateScrollState] = useState(0);
    const [atScrollEnd, updateAtScrollEnd] = useState(false);
    const [buttonPosition, updateButtonPosition] = useState(0);

    const isMobile = useMediaQuery({ query: '(max-width: 430px)' });

    const dimCards = useCallback((element) => {
        const cards = element.children;
        Array.from(cards).forEach((card) => {
            const focusable = card.querySelectorAll('a, button, input, select, textarea, [tabindex]');
            if (!checkInView(element, card, false)) {
                card.classList.add('custom-carousel__item--dimmed');
                card.setAttribute('aria-hidden', 'true');
                if (card.tagName === 'A' || card.tagName === 'BUTTON') {
                    card.setAttribute('tabindex', '-1');
                }
                focusable.forEach((el) => el.setAttribute('tabindex', '-1'));
            } else {
                card.classList.remove('custom-carousel__item--dimmed');
                card.removeAttribute('aria-hidden');
                if (card.tagName === 'A' || card.tagName === 'BUTTON') {
                    card.removeAttribute('tabindex');
                }
                focusable.forEach((el) => el.removeAttribute('tabindex'));
            }
        });
    }, []);

    const getScrollAmount = (element) => {
        const firstChild = element.children[0];
        const style = window.getComputedStyle(element);
        const itemWidth = firstChild.offsetWidth;
        const gap = parseFloat(style.gap);
        const scrollAmount = itemWidth + gap;

        return scrollAmount;
    };

    const updateScroll = useCallback(
        (element) => {
            const position = element.scrollLeft;
            const clientWidth = element.clientWidth;
            const scrollWidth = element.scrollWidth;

            updateScrollState(position);
            if (Math.abs(position + clientWidth - scrollWidth) <= 3) {
                updateAtScrollEnd(true);
            } else {
                updateAtScrollEnd(false);
            }

            dimCards(element);
        },
        [dimCards]
    );

    useEffect(() => {
        updateScroll(scrollContainerRef.current);
        updateButtonPosition(
            (scrollContainerRef.current.clientHeight - 25) / 2
        );
    }, [updateScroll, scrollContainerRef]);

    const onScrollLeft = () => {
        const el = scrollContainerRef.current;

        el.scroll({
            left: scrollPosition - getScrollAmount(el),
            behavior: 'smooth',
        });
    };

    const onScrollRight = () => {
        const el = scrollContainerRef.current;

        el.scroll({
            left: scrollPosition + getScrollAmount(el),
            behavior: 'smooth',
        });
    };

    const checkInView = (container, element, partial) => {
        let xOffset = container.offsetLeft;

        //Get container properties
        let cLeft = container.scrollLeft + xOffset;
        let cRight = cLeft + container.clientWidth + xOffset;

        //Get element properties
        let eLeft = element.offsetLeft;
        let eRight = eLeft + element.clientWidth + xOffset;

        //Check if in view
        let isTotal = eLeft >= cLeft && eRight <= cRight;
        let isPartial =
            partial &&
            ((eLeft < cLeft && eRight > cLeft) ||
                (eRight > cRight && eLeft < cRight));

        //Return outcome
        return isTotal || isPartial;
    };

    return (
        <>
            <div
                className="custom-carousel__scroll-buttons"
                style={{ top: buttonPosition }}
            >
                {scrollPosition !== 0 && (
                    <button
                        className="custom-carousel left"
                        aria-label={translate('general.previous')}
                        onClick={() => onScrollLeft()}
                    >
                        <i></i>
                    </button>
                )}
                {atScrollEnd === false && (
                    <button
                        className="custom-carousel right"
                        aria-label={translate('general.next')}
                        onClick={() => onScrollRight()}
                    >
                        <i></i>
                    </button>
                )}
            </div>
            <div
                onScroll={(e) => updateScroll(e.target)}
                className="custom-carousel__scroll-container"
                ref={scrollContainerRef}
            >
                {children}
            </div>
        </>
    );
};
